import { FC } from 'react';
import { useCountDown } from 'ahooks';
import styled from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import getLocal from '@/app/utils/getLocal';
import { useMonthlyStore } from '@/components/EcocreditsMonthlyMadness/MonthlyProvider';

interface FlashSaleCountdownProps {
    timeInfo: {
        secKillStartTime: number;
        secKillEndTime: number;
    };
    handleEnd?: () => void;
}

const FlashSaleCountdown: FC<FlashSaleCountdownProps> = ({ timeInfo, handleEnd }) => {
    const { useLang, getSystemTime } = useGlobal();
    const { t } = useLang('appreciationday');

    const { secKillisBegin } = useMonthlyStore();

    const [, formattedRes] = useCountDown({
        leftTime: secKillisBegin ? timeInfo.secKillEndTime - getSystemTime() : timeInfo.secKillStartTime - getSystemTime(),
        onEnd: () => handleEnd && handleEnd(),
    });

    const { days, hours, minutes, seconds } = formattedRes;
    const handleCompletion = (val: number) => (val < 10 ? `0${val}` : val);

    return (
        <>
            {secKillisBegin && (
                <div className={styled.flashSaleCountdown}>
                    <div>
                        <span className="time">{handleCompletion(days)}</span>
                        <span>{t('days')}</span>
                    </div>
                    <span className="colon">:</span>
                    <div>
                        <span className="time">{handleCompletion(hours)}</span>
                        <span>{t('hours')}</span>
                    </div>
                    <span className="colon">:</span>
                    <div>
                        <span className="time">{handleCompletion(minutes)}</span>
                        <span>{t('minutes')}</span>
                    </div>
                    <span className="colon">:</span>
                    <div>
                        <span className="time">{handleCompletion(seconds)}</span>
                        <span>{t('seconds')}</span>
                    </div>
                </div>
            )}
        </>
    );
};

export default FlashSaleCountdown;
